/**
 * Token Migration Utility
 *
 * Migrates localStorage tokens from old format to new format
 * Clears old camelCase tokens and forces re-login
 */

/**
 * Check if migration is needed and perform it
 * Should be called once on app initialization
 */
export function migrateTokensIfNeeded() {
  const migrationKey = 'fm_tokens_migrated_to_snake_case';
  const migrationDone = localStorage.getItem(migrationKey);

  if (migrationDone === 'true') {
    // Migration already done
    return false;
  }

  console.log('[Token Migration] Migrating to snake_case token format...');

  // List of old token keys that might exist
  const oldKeys = [
    'accessToken',
    'refreshToken',
    'fm_accessToken',
    'fm_refreshToken',
    'fleetmanager_access_token', // Other possible old formats
    'fleetmanager_refresh_token',
  ];

  // Remove all old token keys
  oldKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      console.log(`[Token Migration] Removing old token: ${key}`);
      localStorage.removeItem(key);
    }
  });

  // Clear current tokens to force re-login with new format
  localStorage.removeItem('fm_access_token');
  localStorage.removeItem('fm_refresh_token');

  // Mark migration as complete
  localStorage.setItem(migrationKey, 'true');

  console.log('[Token Migration] Migration complete. User will need to log in again.');

  return true; // Migration was performed
}

/**
 * Clear all authentication tokens (for troubleshooting)
 */
export function clearAllTokens() {
  const tokenKeys = [
    'fm_access_token',
    'fm_refresh_token',
    'fm_mobile_access_token',
    'fm_mobile_refresh_token',
    'fm_impersonate_token',
    // Old formats
    'accessToken',
    'refreshToken',
    'fm_accessToken',
    'fm_refreshToken',
  ];

  tokenKeys.forEach(key => localStorage.removeItem(key));

  console.log('[Token Migration] All tokens cleared');
}

export default {
  migrateTokensIfNeeded,
  clearAllTokens
};
